export default __webpack_public_path__ + "img/Devops-4.eb6dac49.jpg";